import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getLocalDateTime } from '@skytech/utils'

import { useObject } from './object'
import useSetup from './setup'

export const useLocalTime = () => {
  const setup = useSetup()
  const object = useObject()

  const formatTime = ({ date, locale }: { date: string | Date | null; locale?: Locale }) =>
    getLocalDateTime({
      date,
      locale: locale || object?.locale || setup?.locale || DEFAULT_LOCALE,
    })

  return { formatTime }
}
